import { render, staticRenderFns } from "./tabs-pages.vue?vue&type=template&id=ece23a64&scoped=true"
import script from "./tabs-pages.vue?vue&type=script&lang=js"
export * from "./tabs-pages.vue?vue&type=script&lang=js"
import style0 from "./tabs-pages.vue?vue&type=style&index=0&id=ece23a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece23a64",
  null
  
)

export default component.exports